import {analyticsLogEvent} from '../api'

type LayerAction = 'open' | 'close'

interface Parameters {
    /** Interaction with the layer: open on display, close on dismiss. */
    action: LayerAction
    /** Master SKU of the product shown in the confirmation layer. */
    sku: string
}

/**
 * @name analyticsEventConfirmLayerAddToCart
 *
 * @event
 *
 * @description
 * Tracks the mobile add-to-cart confirmation layer open/close.
 * Manuale BitBang "GTM Tracciamenti – PDP PWA" v1.0 §3.1.6.
 *
 * This layer is mobile-only (the sticky add-to-cart popover shown after a size is selected).
 *
 * dataLayer shape:
 * `{ event: 'custom_event', eventCategory: 'confirm_layer_add_to_cart', eventAction: 'open'|'close', eventLabel: '[PRODUCT SKU]' }`
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {LayerAction} params.action - open/close, mapped to `eventAction`.
 * @param {string} params.sku - Product master SKU, mapped to `eventLabel`.
 */
export function analyticsEventConfirmLayerAddToCart({action, sku}: Parameters) {
    analyticsLogEvent('custom_event', {
        eventCategory: 'confirm_layer_add_to_cart',
        eventAction: action,
        eventLabel: sku,
    })
}
